module.exports = __webpack_public_path__ + "img/028.71d04c20.png";